import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { ModalController } from '@ionic/angular';
import { Constants } from '../../constants/constants';
import { AssetService } from 'src/app/services/asset/asset.service';
import { ClientService } from 'src/app/services/client/client.service';
import { AssetPresetFieldsModel } from 'src/app/models/asset_preset_fields.model';
import { AssetTypeModel } from 'src/app/models/asset-type.model';



@Component({
  selector: 'modal-new-asset-preset',
  templateUrl: './modal-new-asset-preset.component.html',
  styleUrls: ['./modal-new-asset-preset.component.scss'],
})
export class ModalNewAssetPresetComponent implements OnInit {


  title = "Create Asset Type Preset";
  isEditing = false;

  selectedAssetTypeDetails: AssetTypeModel;
  preset: AssetTypeModel;
  originalPreset: any;
  unEditedPresetFields: any;
  presetNameError: boolean = false;
  
  @ViewChild('popover') popover;
  isOpen = false;
  selectedField: any;


  constructor(public appearanceService: AppearanceService,
   public userService: UserService, public modalController: ModalController,
   public assetService: AssetService, public clientService: ClientService) {

  }


  ngOnInit() 
  {
    this.preset = JSON.parse(JSON.stringify(this.selectedAssetTypeDetails));
    
    if (this.originalPreset)
    {
      this.preset.presetName = this.originalPreset.name;

      this.isEditing = true;
      this.title = "Edit " + this.preset.presetName;

      for (var i = 0; i < this.preset.fields.length; i++)
      {
        for (var y = 0; y < this.originalPreset.defaultValues.length; y++)
        {
          if(this.preset.fields[i].uid == this.originalPreset.defaultValues[y].uid)
          {
            this.preset.fields[i].value = this.originalPreset.defaultValues[y].val;
          }
        }
      }

      this.unEditedPresetFields = JSON.parse(JSON.stringify(this.preset.fields));
    }
  }


  ionViewWillEnter()
  {

  }


  ionViewWillLeave()
  {

  }


  openPopover(field, e: Event) 
  {
    this.selectedField = field;
    this.popover.event = e;
    this.isOpen = true;
  }


  createPreset()
  {
    if (this.doesPresetHaveErrors())
    {
      return;
    }

    var fieldColumn = [];

    for (var i = 0; i < this.preset.fields.length; i++)
    {
      var field = { uid: this.preset.fields[i].uid, val: this.preset.fields[i].value }
      fieldColumn.push(field);
    }

    var payload = {
      ClientUid: this.clientService.getClientUid(),
      OrganisationUid: this.clientService.getOrganisationUid(),
      PresetName: this.preset.presetName,
      AssetTypeUid: this.preset.assetTypeUid,
      DefaultValues: JSON.stringify(fieldColumn)
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.createNewAssetTypePreset(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          var allFieldValuePresets = Array<AssetPresetFieldsModel>();

          for (var i = 0; i < response.AssetTypePresets.length; i++)
          {
            var entry = response.AssetTypePresets[i];
            
            var newPreset = new AssetPresetFieldsModel();

            newPreset.uid           = entry.assetPresetUid;
            newPreset.name          = entry.assetPresetName;
            newPreset.defaultValues = entry.assetPresetDefaultValues;

            allFieldValuePresets.push(newPreset);
          }

          var returnData = { presets: allFieldValuePresets };
          this.closeModal(returnData);
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  updatePreset()
  {
    if (JSON.stringify(this.unEditedPresetFields) == JSON.stringify(this.preset.fields) && (this.preset.presetName == this.originalPreset.name))
    {
      this.closeModal();
      return;
    }

    if (this.doesPresetHaveErrors())
    {
      return;
    }

    var fieldColumn = [];

    for (var i = 0; i < this.preset.fields.length; i++)
    {
      var field = { uid: this.preset.fields[i].uid, val: this.preset.fields[i].value }
      fieldColumn.push(field);
    }

    var payload = {
      OrganisationUid: this.clientService.getOrganisationUid(),
      PresetUid: this.originalPreset.uid,
      PresetName: this.preset.presetName,
      AssetTypeUid: this.preset.assetTypeUid,
      DefaultValues: JSON.stringify(fieldColumn)
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.updateAssetTypePreset(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          var allFieldValuePresets = Array<AssetPresetFieldsModel>();

          for (var i = 0; i < response.AssetTypePresets.length; i++)
          {
            var entry = response.AssetTypePresets[i];
            
            var newPreset = new AssetPresetFieldsModel();

            newPreset.uid           = entry.assetPresetUid;
            newPreset.name          = entry.assetPresetName;
            newPreset.defaultValues = entry.assetPresetDefaultValues;

            allFieldValuePresets.push(newPreset);
          }

          var returnData = { presets: allFieldValuePresets };

          this.closeModal(returnData);
          this.appearanceService.presentToast("Preset Updated.", Constants.TOAST_INFO);
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  doesPresetHaveErrors()
  {
    var errorFound = false;
    this.presetNameError = false;

    if (!this.preset.presetName)
    {
      errorFound = true;
      this.presetNameError = true;
    }
    else
    {
      if (this.preset.presetName == "")
      {
        errorFound = true;
        this.presetNameError = true;
      }
    }

    /*
    for (var i = 0; i < this.preset.fields.length; i++)
    {
      this.preset.fields[i].error = false;

      if (!this.preset.fields[i].value)
      {
        errorFound = true;
        this.preset.fields[i].error = true;
      }
      else
      {
        if (this.preset.fields[i].value == "")
        {
          errorFound = true;
          this.preset.fields[i].error = true;
        }
      }
    }
    */

    return errorFound;
  }


  closeModal(returnData = null)
  {
    this.modalController.dismiss(returnData, null, 'NewAssetPresetModal');
  }
}
